import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';
import ActivityStore from './Activity/ActivityStore';
import constants from 'Constants';
import * as utils from 'Utils';


class ActivitiesPageStore {

  @setter @observable activities;
  @setter @observable currentPage;
  @setter @observable numPages;
  @setter @observable numRecords;
  @setter @observable recordExists;

  @setter @observable paramPage;
  @setter @toggle @observable isLoading;

  constructor() {
    this.reset();
  }

  @action reset() {
    this.activities = [];
    this.currentPage = 0;
    this.numPages = 0;
    this.numRecords = 0;
    this.recordExists = false;

    this.paramPage = null;
    this.isLoading = true;
  }

  getDeserializeMappers() {
    return [
      {"field": "activities", "accessor": "paginator.results", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": ActivityStore},
      {"field": "currentPage", "accessor": "paginator.current_page"},
      {"field": "numPages", "accessor": "paginator.num_pages"},
      {"field": "numRecords", "accessor": "paginator.num_records"},
      {"field": "recordExists", "accessor": "record_exists"},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @computed get params() {
    const data = {};
    data['page'] = this.paramPage;
    return data;
  }

  @action setFields(data) {
    let self = this;
    for (var key in data) {
      let value = data[key];
      self[key] = value;
    }
  }
}


const activitiesPageStore = new ActivitiesPageStore();
export default activitiesPageStore;
export { ActivitiesPageStore };
